
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'RangeSlider',
  emits: ['update:modelValue'],
  props: {
    modelValue: {
      type: [Number, String],
      required: true
    },
    min: {
      type: Number,
      default: -50
    },
    max: {
      type: Number,
      default: 50
    },
    step: {
      type: Number,
      default: 1
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    updateValue(event: Event) {
      const target = event.target as HTMLInputElement;
      const value = parseInt(target.value);
      this.$emit('update:modelValue', value);
    }
  }
});
